import React from 'react'
import { StyledMetadata } from './styled'

const Metadata = ({ children, as }) => {
	return <StyledMetadata as={as}>{children}</StyledMetadata>
}

export default Metadata
